import produce from 'immer'
import { Reducer } from 'redux'

import { TEXT_EDITOR_SET_SELECTION_FUNCTION } from 'redux/actions/types'

interface TextEditorState {
  setSelection: Function | null
}

const initialState: TextEditorState = {
  setSelection: null
}

const textEditor: Reducer<TextEditorState, any> = (state = initialState, action) => {
  switch (action.type) {
    case TEXT_EDITOR_SET_SELECTION_FUNCTION:
      return produce(state, draft => {
        draft.setSelection = action.setSelection
      })
    default:
      return state
  }
}

export default textEditor
